// routes/s/$orgId/$portalId/route.tsx
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AccessGuard } from '@security/auth/AccessGuard.tsx';

const commonSchema = z.object({
  portalId: z.coerce.number(),
  orgId: z.coerce.number(),
});

export const Route = createFileRoute('/s/$orgId/$portalId')({
  params: {
    parse: p => commonSchema.parse(p),
  },
  // AccessGuard ověří přístup k org+portálu (z /api/auth/me) a uvnitř renderuje Outlet
  // pro pod-routy. Když přístup není → stránka "Nemáte přístup".
  component: () => <AccessGuard type="supplier" />,
});
